export default __webpack_public_path__ + "static/media/0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6.80c6afd1.png";